// removed by extract-text-webpack-plugin
module.exports = {"control":"cms__ControlPane__control","label":"cms__ControlPane__label","widget":"cms__ControlPane__widget"};


//////////////////
// WEBPACK FOOTER
// ./components/ControlPanel/ControlPane.css
// module id = 251
// module chunks = 0